import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class MarketingBlock extends React.Component {

  static get propTypes() {
    return {
      className: PropTypes.string,
      asideClassName: PropTypes.string,
      children: PropTypes.node,
      aside: PropTypes.node,
      divider: PropTypes.bool,
      inverse: PropTypes.bool,
      narrow: PropTypes.bool,
      ratio: PropTypes.oneOf(['4to6', '1to2']),
      align: PropTypes.oneOf(['top', 'middle']),
    };
  }

  render() {
    const { children, aside, className, asideClassName, divider, inverse, ratio, align, narrow } = this.props;
    const elementClass = 'ea-marketing-block';
    const plRatio = `ea-marketing-block--${ratio}ratio`;
    const alignment = `ea-marketing-block--align-${align}`;

    const classNames = classnames(elementClass, className, {
      [alignment]: align,
      'ea-marketing-block--narrow': narrow,
      'ea-marketing-block--divider': divider,
      'ea-marketing-block--inverse': inverse,
      [plRatio]: ratio,
    });

    const asideClassNames = classnames('ea-marketing-block__aside', asideClassName);

    return (
      <section className={classNames}>
        <div className='ea-marketing-block__content'>
          <aside className={asideClassNames} style={{ paddingRight: 0 }}>
            { aside }
          </aside>
          <article className='ea-marketing-block__article' style={{ paddingLeft: '15px' }}>
            { children }
          </article>
        </div>
      </section>);
  }
}

export default MarketingBlock;
export { MarketingBlock };



// WEBPACK FOOTER //
// ./web/js/components/react-patterns/MarketingBlock.js